import { useState } from "react";
import { useQuery } from "react-query";
import FilterBar from "../../Components/UI/filterbar";
import DataTable from "../../Components/UI/table/DataTable";
import TableActions from "../../Components/UI/table/TableActions";
import StatusBadge from "../../Components/UI/statusBadge";
import PosModal from "../../Components/system settings/storemodals/posmodal";
import { getPos, deletePos, updatePos } from "../../MyApi/pos";
import i18next from "i18next";

const PosTab = ({ currentPage, setCurrentPage, filters, setFilters }) => {
  const [posModalOpen, setPosModalOpen] = useState(false);
  const [posModalMode, setPosModalMode] = useState("add");
  const [posModalId, setPosModalId] = useState(null);
  const lang = i18next.language;
  const {
    data: posData,
    isLoading: posLoading,
    isFetching: posFetching,
    refetch: posRefetch,
  } = useQuery(
    ["pos", currentPage, filters],
    () => {
      return getPos(currentPage, filters);
    },
    {
      keepPreviousData: true,
    },
  );

  const listData = posData?.data?.terminals || [];
  const totalItems = posData?.data?.pagination?.total || 0;
  const lastPage = posData?.data?.pagination?.last_page || 0;

  const posColumns = [
    { label: "معرف نقطة البيع", accessor: "id" },
    { label: "اسم الجهاز", accessor: "name" },
    { label: "المتجر", accessor: "store_name" },
    { label: "عنوان", accessor: "store_address" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    { label: "آخر مزامنة", accessor: "last_sync" },
    { label: "الطلبات (اليوم)", accessor: "count_today_orders" },
    { label: "المبيعات (اليوم)", accessor: "amount_today_orders" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => openPosModal("show", row.id)}
          edit={() => openPosModal("edit", row.id)}
          deleteFn={deletePos}
          deletePermission={"delete_pos_terminal"}
          viewPermission={"view_pos_terminal"}
          editPermission={"update_pos_terminal"}
          id={row.id}
          isLoading={posLoading}
          mutationKey={"deletePos"}
          refetch={posRefetch}
          is_active={row.is_active}
          togglePermission={"update_store"}
          toggleMutationKey={"togglePosActive"}
          toggleFn={(id, status) =>
          updatePos({ is_active: status, _method: "PUT", lang }, id)
          }
        />
      ),
    },
  ];

  const openPosModal = (mode, id) => {
    setPosModalMode(mode);
    setPosModalOpen(true);
    setPosModalId(id);
  };

  const closePosModal = () => {
    setPosModalOpen(false);
    setPosModalId(null);
  };

  const filtersConfig = { search: "search", status: "status", date: "date" };

  return (
    <>
      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig}
      />
      <DataTable
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalItems={totalItems}
        itemsPerPage={lastPage}
        onAddClick={() => openPosModal("add")}
        columns={posColumns}
        data={listData}
        title="نقاط البيع"
        actionLabel="إضافة"
        isLoading={posLoading}
        isFetching={posFetching}
        createPermission="create_pos_terminal"
      />
      {posModalOpen && (
        <PosModal
          show={posModalOpen}
          onClose={closePosModal}
          refetch={posRefetch}
          mode={posModalMode}
          id={posModalId}
        />
      )}
    </>
  );
};

export default PosTab;
